function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M521.5 303C521.5 341.788 505.926 385.9 481.307 431.051C456.799 475.997 423.964 520.832 390.874 560.779C357.819 600.683 324.73 635.448 299.887 660.249C287.474 672.642 277.137 682.528 269.918 689.304C268.88 690.279 267.906 691.189 267 692.033C266.094 691.189 265.12 690.279 264.082 689.304C256.863 682.528 246.526 672.642 234.113 660.249C209.27 635.448 176.181 600.683 143.126 560.779C110.036 520.832 77.2006 475.997 52.6933 431.051C28.0741 385.9 12.5 341.788 12.5 303C12.5 141.029 127.882 12.5 267 12.5C406.118 12.5 521.5 141.029 521.5 303Z",
  fill: "black",
  stroke: "white",
  strokeWidth: 25
});

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 709,
    viewBox: "0 0 534 709",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.573db784.svg";
export { ForwardRef as ReactComponent };